import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  FormControl,
  RadioGroup,
  Switch,
  FormControlLabel,
  Typography,
  DialogActions,
  Radio,
  InputLabel,
  Stack,
  Button,
  OutlinedInput,
  Select,
  TextField,
  MenuItem,
  Chip,
  DialogContentText,
  InputAdornment,
  Checkbox,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import api from 'src/services/BaseService';
import CompleteButton from '../shared/CompleteButton';
import { getUserTypeLabel } from 'src/utils/getUserLabel';
import { useLocalization } from 'src/context/LocalizationContext';

const AddEditUserModal = ({
  dialogOpen,
  setDialogOpen,
  modalType,
  user,
  malls,
  setUser,
  getUserList,
}) => {
  const { language } = useLocalization();

  const [formData, setFormData] = useState({
    name: '',
    surname: '',
    password: '',
    email: '',
    phone: '',
    username: '',
    frontAuth: '',
    type: 'user',
  });
  const [selectpass, setSelectPass] = useState('');
  const [selectedMalls, setSelectedMalls] = useState([]);
  const [storeNone, setStoreNone] = useState(true);
  const [selectedBranches, setSelectedBranches] = useState([]);
  const [branches, setBranches] = useState([]);
  const [selectedRole, setSelectedRole] = useState([]);
  const [userActive, setUserActive] = useState(true);
  const [canCancel, setCanCancel] = useState(false);
  const [isResetPassButtonDisabled, setIsResetPassButtonDisabled] =
    useState(false);
  const [dialogPasswordOpen, setDialogPasswordOpen] = useState(false);

  const isHR = formData.type === 'human-resource';
  const isAccountant = formData.type === 'accountant';
  const isCorporational = formData.type === 'corporational';

  const handleChangeUserType = (event) => {
    const { value } = event.target;

    setFormData((prevData) => ({
      ...prevData,
      type: value,
    }));

    if (value === 'corporational' || value === 'user') {
      setSelectedRole([]);
      setStoreNone(true);
      setSelectedMalls([]);
      setSelectedBranches([]);
    } else if (value === 'highadmin') {
      setSelectedRole([]);
      setSelectedBranches([]);
      setStoreNone(false);
      setSelectedMalls(malls);
    } else if (value === 'accountant') {
      // Accountant: AVM bazlı, yetki kutuları görünmesin (aşağıda render'da gizleniyor)
      setSelectedRole(['accountant']);
      setSelectedBranches([]);
      setStoreNone(false);
      setSelectedMalls([]);
    } else if (value === 'human-resource') {
      // HR: AVM bazlı, frontAuth sabit 'hr' ve yetki kutuları gizli
      setSelectedRole(['hr']);
      setSelectedBranches([]);
      setStoreNone(false);
      setSelectedMalls([]);
    } else {
      // admin vs.
      setSelectedRole([]);
      setSelectedBranches([]);
      setStoreNone(false);
      setSelectedMalls([]);
    }

    // HR ve Accountant için iptal yetkisi anahtarı kapansın
    if (value === 'human-resource' || value === 'accountant') {
      setCanCancel(false);
    }
  };

  const handleDialogPasswordOpen = () => {
    setDialogPasswordOpen(true);
  };

  const handleDialogPasswordClose = () => {
    setDialogPasswordOpen(false);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    if (name === 'selectedBranch') {
      setSelectedBranches(value);
    }
  };

  const getBranches = async (mallIds) => {
    const uniqueMallIds = Array.from(new Set(mallIds));
    const allBranches = [];

    try {
      const requests = uniqueMallIds.map(async (mallId) => {
        const response = await api.post('flow/get-malls-branches', {
          mallID: mallId,
          withLocations: false,
        });

        if (response.data.status) {
          const mallTitle = malls.find((m) => m.id === mallId)?.title || '';
          const branchesWithMall = response.data.result.map((branch) => ({
            ...branch,
            mallTitle,
          }));

          return branchesWithMall;
        } else {
          return [];
        }
      });

      const mallBranchesArray = await Promise.all(requests);

      mallBranchesArray.forEach((mallBranches) => {
        allBranches.push(...mallBranches);
      });

      const uniqueBranches = allBranches.filter(
        (branch, index, self) =>
          index === self.findIndex((b) => b.branchID === branch.branchID)
      );

      setBranches(uniqueBranches);
    } catch (error) {
      console.log(error);
    }
  };

  const getBranchesByID = async (mallId) => {
    try {
      const response = await api.post('flow/get-malls-branches', {
        mallID: mallId,
        withLocations: false,
      });

      if (response.data.status) {
        const mallTitle = malls.find((m) => m.id === mallId)?.title || '';

        const newBranches = response.data.result.map((branch) => ({
          ...branch,
          mallTitle,
        }));

        setBranches((prevBranches) => {
          const allBranches = [...prevBranches, ...newBranches];

          const uniqueBranches = allBranches.filter(
            (branch, index, self) =>
              index === self.findIndex((b) => b.branchID === branch.branchID)
          );

          return uniqueBranches;
        });
      } else {
        console.log(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleMallChange = async (e) => {
    const { value } = e.target;
    const previousSelection = selectedMalls || [];

    const mergedSelection = [
      ...previousSelection,
      ...value.filter((item) => !previousSelection.includes(item)),
    ];

    setSelectedMalls(mergedSelection);
    // AVM seçimi değiştikçe sadece yeni seçilenin branch'lerini getir
    if (value?.length > 0) {
      const last = value[value.length - 1];
      if (last?.id) getBranchesByID(last.id);
    }
  };

  const handleSetUserInactive = (isActive) => {
    const userID = user?.id;
    if (userID) {
      const endpoint = isActive
        ? 'flow/user-set-active'
        : 'flow/user-set-passive';

      api
        .post(endpoint, { userID })
        .then((response) => {
          if (response.data.status) {
            toast.success(
              `Kullanıcı başarıyla ${
                isActive ? 'aktif' : 'pasif'
              } hale getirildi.`
            );
            setUserActive(isActive);
            setTimeout(() => {
              document
                .getElementById('userSwitch')
                .scrollIntoView({ behavior: 'smooth' });
              setTimeout(() => {
                window.location.reload();
              }, 1200);
            }, 1000);
          } else {
            toast.error(
              `Kullanıcı ${
                isActive ? 'aktif' : 'pasif'
              } hale getirilirken bir hata oluştu.`
            );
          }
        })
        .catch((error) => {
          console.error('API Hatası:', error);
          toast.error(
            `Kullanıcı ${
              isActive ? 'aktif' : 'pasif'
            } hale getirilirken bir hata oluştu.`
          );
        });
    } else {
      toast.error('Lütfen bir kullanıcı seçin.');
    }
  };

  const handleSwitchChange = () => {
    setCanCancel(!canCancel);
    if (!canCancel) {
      setSelectedRole([...selectedRole, 'can-cancel']);
    } else {
      setSelectedRole(selectedRole.filter((role) => role !== 'can-cancel'));
    }
  };

  const handleRoleChange = (role) => {
    setSelectedRole((prevRoles) => {
      if (prevRoles?.includes(role)) {
        return prevRoles?.filter((r) => r !== role);
      } else {
        return [...prevRoles, role];
      }
    });
  };

  const handleRemoveMall = (_mall) => {
    const remainingMalls = selectedMalls.filter((mall) => mall !== _mall);
    const remainingBranches = branches.filter(
      (branch) => branch.mallID !== _mall.id
    );

    const remainingSelectedBranches = [];

    for (let i = 0; i < selectedBranches?.length; i++) {
      if (
        remainingBranches.filter(
          (branch) => branch.branchID === selectedBranches[i]
        ).length > 0
      ) {
        remainingSelectedBranches.push(selectedBranches[i]);
      }
    }

    setSelectedMalls(remainingMalls);
    setBranches(remainingBranches);
    setSelectedBranches(remainingSelectedBranches);
  };

  const handleRemoveBranch = (branchID) => {
    if (selectedBranches?.length === 1) {
      setSelectedBranches([]);
    } else {
      const remainingBranches = selectedBranches.filter(
        (id) => id !== branchID
      );
      setSelectedBranches(remainingBranches);
    }
  };

  const buildAllPoints = () => {
    const allPoints = [];
    for (let i = 0; i < selectedMalls?.length; i++) {
      for (let j = 0; j < selectedMalls[i].offices?.length; j++) {
        allPoints.push({
          id: selectedMalls[i].offices[j].id,
          isFirstResponsible: i === 0 && j === 0,
        });
      }
    }
    return allPoints;
  };

  const handleComplete = () => {
    const effectiveFrontAuth = isHR
      ? ['hr']
      : isAccountant
      ? ['accountant']
      : selectedRole;

    const commonCreateOrUpdateChecks =
      formData?.name?.length >= 2 &&
      formData?.surname?.length >= 2 &&
      formData?.email?.length > 2 &&
      formData?.phone?.length > 2 &&
      effectiveFrontAuth.length >= 1 &&
      ((isCorporational && selectedBranches?.length > 0) ||
        (!isCorporational && selectedMalls?.length > 0));

    if (modalType === 'new') {
      if (!commonCreateOrUpdateChecks || formData?.password?.length <= 2) {
        toast.error('Zorunlu alanları doldurunuz...');
        return;
      }
      if (formData.password !== selectpass) {
        toast.error('Şifreler eşleşmiyor. Lütfen tekrar deneyin.');
        return;
      }

      if (isCorporational) {
        api
          .post('flow/user-create', {
            branchID: selectedBranches[0],
            mallID: selectedMalls[0].id,
            email: formData.email,
            name: formData.name,
            type: formData.type,
            lastname: formData.surname,
            phone: formData.phone,
            username: formData.username,
            password: formData.password,
            isAdministrator: effectiveFrontAuth.includes('manager'),
            accountCategory: 'store',
            frontAuth: effectiveFrontAuth,
            authLocations: {
              branch: selectedBranches,
            },
          })
          .then((response) => {
            if (response.data.status) {
              toast.success('Kullanıcı başarıyla oluşturuldu.');
              getUserList('1');
              handleCloseDialog();
            } else {
              if (response.data.message === 'Username must be unique') {
                toast.error(
                  'Bu kullanıcı adı ile daha önce hesap oluşturulmuştur. Lütfen farklı bir kullanıcı adıyla tekrar deneyiniz'
                );
              } else {
                toast.error(response.data.message);
              }
            }
          })
          .catch(() => {
            toast.error('Kullanıcı oluşturulurken bir hata oluştu.');
          });
      } else {
        const allPoints = buildAllPoints();

        api
          .post('flow/users-create-employee', {
            mallID: selectedMalls[0].id,
            allowedPoints: allPoints,
            email: formData.email,
            name: formData.name,
            type: formData.type,
            lastname: formData.surname,
            phone: formData.phone,
            username: formData.username,
            password: formData.password,
            isAdministrator:
              effectiveFrontAuth.includes('manager') ||
              effectiveFrontAuth.includes('regional-manager'),
            accountCategory: 'mall-logistics',
            frontAuth: effectiveFrontAuth,
            authLocations: {
              mall: selectedMalls?.map((mall) => mall.id),
            },
          })
          .then((response) => {
            if (response.data.status) {
              toast.success('Kullanıcı başarıyla oluşturuldu.');
              getUserList('1');
              handleCloseDialog();
            } else {
              if (response.data.message === 'Username must be unique') {
                toast.error(
                  'Bu kullanıcı adı ile daha önce hesap oluşturulmuştur. Lütfen farklı bir kullanıcı adıyla tekrar deneyiniz'
                );
              } else {
                toast.error(response.data.message);
              }
            }
          })
          .catch(() => {
            toast.error('Kullanıcı oluşturulurken bir hata oluştu.');
          });
      }
    } else {
      // edit
      if (!commonCreateOrUpdateChecks) {
        toast.error('Zorunlu alanları doldurunuz...');
        return;
      }

      if (isCorporational) {
        api
          .post('users/update-profile', {
            userID: user.id,
            branchID: selectedBranches[0],
            mallID: selectedMalls[0].id,
            email: formData.email,
            name: formData.name,
            lastname: formData.surname,
            phone: formData.phone,
            username: formData.username,
            isAdministrator: effectiveFrontAuth.includes('manager'),
            accountCategory: 'store',
            frontAuth: effectiveFrontAuth,
            authLocations: {
              branch: selectedBranches,
            },
          })
          .then((response) => {
            if (response.data.status) {
              toast.success('Kullanıcı başarıyla güncellendi.');
              getUserList('1');
              handleCloseDialog();
            } else {
              toast.error(response.data.message);
            }
          })
          .catch(() => {
            toast.error('Kullanıcı oluşturulurken bir hata oluştu.');
          });
      } else {
        const allPoints = buildAllPoints();

        api
          .post('users/update-profile', {
            userID: user.id,
            mallID: selectedMalls[0].id,
            allowedPoints: allPoints,
            email: formData.email,
            name: formData.name,
            lastname: formData.surname,
            phone: formData.phone,
            username: formData.username,
            isAdministrator:
              effectiveFrontAuth.includes('manager') ||
              effectiveFrontAuth.includes('regional-manager'),
            accountCategory: 'mall-logistics',
            frontAuth: effectiveFrontAuth,
            authLocations: {
              mall: selectedMalls?.map((mall) => mall.id),
            },
          })
          .then(() => {
            api
              .post('flow/users-create-employee-allowed-points', {
                userID: user.id,
                allowedPoints: allPoints,
              })
              .then((res) => {
                if (res.data.status) {
                  toast.success('Kullanıcı başarıyla güncellendi.');
                  getUserList('1');
                  handleCloseDialog();
                } else {
                  toast.error(res.data.message);
                }
              })
              .catch((err) => {
                console.log(err);
                toast.error('AVM noktaları tanımlanırken bir hata oluştu.');
              });
          })
          .catch(() => {
            toast.error('Kullanıcı oluşturulurken bir hata oluştu.');
          });
      }
    }
  };

  const handleResetPassword = () => {
    setIsResetPassButtonDisabled(true);
    api
      .post('flow/user-forced-reset-password', {
        userID: user.id,
      })
      .then((response) => {
        if (response.data) {
          setFormData({
            ...formData,
            password: response.data.result,
          });
          setIsResetPassButtonDisabled(false);
          handleDialogPasswordOpen();
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        toast.error(error.message);
      });
  };

  const handleCopyPassword = () => {
    navigator.clipboard
      .writeText(formData.password)
      .then(() => {})
      .catch((err) => {
        console.error('Şifre kopyalanırken bir hata oluştu:', err);
      });
  };

  useEffect(() => {
    if (dialogOpen) {
      if (modalType === 'edit') {
        setFormData({
          name: user.name,
          surname: user.lastname,
          email: user.email,
          phone: user.phone,
          username: user.username,
          frontAuth: user.frontAuth,
          type: user.type,
        });

        setUserActive(user.status !== '0');

        // Edit modda HR ise frontAuth sabit kalsın
        if (user.type === 'human-resource') {
          setSelectedRole(['hr']);
          setCanCancel(false);
        } else if (user.type === 'accountant') {
          setSelectedRole(['accountant']);
          setCanCancel(false);
        } else {
          setSelectedRole(user.frontAuth);
          if (user.type !== 'corporational') {
            setCanCancel(user.frontAuth?.includes('can-cancel'));
          }
        }

        if (user.type === 'corporational') {
          api
            .post('flow/get-user-auth-locations', {
              userID: user.id,
            })
            .then((res) => {
              const mallIDs = res.data.result.branch?.map(
                (branch) => branch.mallID
              );
              let uniqueMallIDs = [...new Set(mallIDs)];
              let userMallsArr = [];

              for (let i = 0; i < uniqueMallIDs.length; i++) {
                const userMalls = malls.find(
                  (mall) => mall.id === uniqueMallIDs[i]
                );
                userMallsArr.push(userMalls);
              }

              setSelectedMalls(userMallsArr);
              getBranches(userMallsArr?.map((mall) => mall.id));

              let userBranches = [];
              for (let i = 0; i < user.authLocations?.branch?.length; i++) {
                userBranches.push(user.authLocations?.branch[i]);
              }

              setSelectedBranches(userBranches);
            })
            .catch(() => {
              setSelectedMalls([]);
              setSelectedBranches([]);
            });
        } else {
          api
            .post('flow/get-user-auth-locations', {
              userID: user.id,
            })
            .then((res) => {
              const mallIDs = res?.data?.result?.mall?.map((item) => item.id);
              let uniqueMallIDs = [...new Set(mallIDs)];
              let userMallsArr = [];

              for (let i = 0; i < uniqueMallIDs?.length; i++) {
                const userMalls = malls.find(
                  (mall) => mall.id === uniqueMallIDs[i]
                );
                userMallsArr.push(userMalls);
              }

              setSelectedMalls(userMallsArr);
            })
            .catch(() => {
              setSelectedMalls([]);
            });
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dialogOpen]);

  const handleCloseDialog = () => {
    setFormData({});
    setSelectPass();
    setSelectedBranches([]);
    setSelectedMalls([]);
    setSelectedRole([]);
    setDialogOpen(false);
    setCanCancel(false);
    setUser({});
  };

  return (
    <Dialog
      className="dialogs"
      open={dialogOpen}
      onClose={() => handleCloseDialog()}
    >
      <div className="page-width">
        <DialogTitle style={{ padding: '20px 24px' }}>
          {modalType === 'new'
            ? language.commons.add_user
            : language.commons.update_user_info}
        </DialogTitle>
        <DialogTitle
          style={{
            fontWeight: '400',
            color: 'gray',
            margin: '0',
            fontSize: '15px',
            padding: '0px 24px',
          }}
        >
          {modalType === 'new'
            ? language.components.AddEditUserModal.list_warning
            : language.components.AddEditUserModal.info_warning}
        </DialogTitle>
      </div>

      <hr />

      <DialogContent>
        <>
          {modalType === 'edit' && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '5%',
              }}
            >
              <Typography>
                ({getUserTypeLabel(user?.type)}){' '}
                <strong style={{ color: 'blue' }}>
                  {user?.name} {user?.lastname}
                </strong>{' '}
                {language.components.AddEditUserModal.authority}:
              </Typography>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Typography style={{ display: 'flex', alignItems: 'center' }}>
                  <div>{language.commons.labels.user_status}:</div>
                  <div
                    style={{
                      color: userActive ? 'green' : 'red',
                      marginInline: '5px',
                    }}
                  >
                    {userActive ? 'Aktif' : 'Pasif'}
                  </div>
                  <Switch
                    id="userSwitch"
                    checked={userActive}
                    onChange={() => handleSetUserInactive(!userActive)}
                    name="status"
                    color="primary"
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                  />
                </Typography>
              </div>
            </div>
          )}

          {modalType === 'new' && (
            <div
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                flexDirection: 'column',
                gap: '10px',
              }}
            >
              <div>{language.commons.column.user_type}</div>
              <Grid>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    defaultValue={formData.type}
                  >
                    <FormControlLabel
                      value="highadmin"
                      control={<Radio />}
                      label={language.commons.roles.high_admin}
                      onClick={handleChangeUserType}
                    />
                    <FormControlLabel
                      value="admin"
                      control={<Radio />}
                      label={language.commons.roles.admin}
                      onClick={handleChangeUserType}
                    />
                    <FormControlLabel
                      value="corporational"
                      control={<Radio />}
                      label={language.commons.roles.store_user}
                      onClick={handleChangeUserType}
                    />
                    <FormControlLabel
                      value="user"
                      control={<Radio />}
                      label={language.commons.roles.user}
                      onClick={handleChangeUserType}
                    />
                    <FormControlLabel
                      value="accountant"
                      control={<Radio />}
                      label={language.commons.roles.accountant}
                      onClick={handleChangeUserType}
                    />
                    <FormControlLabel
                      value="human-resource"
                      control={<Radio />}
                      label={
                        language?.commons?.roles?.human_resource ||
                        'İnsan Kaynakları'
                      }
                      onClick={handleChangeUserType}
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </div>
          )}

          <hr />

          <div
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              flexDirection: 'column',
              gap: '10px',
            }}
          >
            <div>{language.commons.user_infos}</div>
            <Grid xs={12} spacing={2} container style={{ textAlign: 'right' }}>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel htmlFor="outlined-adornment-amount">
                    {language.commons.labels.username}
                  </InputLabel>
                  <OutlinedInput
                    id="outlined-adornment-amount"
                    label={language.commons.labels.username}
                    name="username"
                    placeholder={language.commons.labels.username}
                    onChange={handleChange}
                    value={formData.username}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={6}>
                <TextField
                  name="name"
                  label={language.commons.labels.name}
                  placeholder={language.commons.labels.name}
                  variant="outlined"
                  required
                  value={formData.name}
                  onChange={handleChange}
                  fullWidth
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  name="surname"
                  label={language.commons.labels.lastname}
                  required
                  placeholder={language.commons.labels.lastname}
                  variant="outlined"
                  value={formData.surname}
                  onChange={handleChange}
                  fullWidth
                />
              </Grid>
              {modalType === 'edit' ? (
                <CompleteButton
                  label={language.commons.labels.reset_password}
                  disabled={isResetPassButtonDisabled}
                  onClick={() => handleResetPassword()}
                  sx={{
                    mt: 2,
                    ml: 'auto',
                    float: 'left',
                    width: '210px  ',
                  }}
                />
              ) : (
                <>
                  <Grid item xs={6}>
                    <TextField
                      name="password"
                      label={language.commons.labels.password}
                      required
                      placeholder={language.commons.labels.password}
                      variant="outlined"
                      type="password"
                      value={
                        modalType === 'edit' ? user.password : formData.password
                      }
                      onChange={handleChange}
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <TextField
                      name="selectpass"
                      label={language.commons.labels.again_password}
                      required
                      placeholder={language.commons.labels.again_password}
                      variant="outlined"
                      type="password"
                      value={selectpass}
                      onChange={(e) => setSelectPass(e.target.value)}
                      fullWidth
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </div>

          <hr />

          <div
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              flexDirection: 'column',
              gap: '10px',
            }}
          >
            <div>{language.commons.user_contact}</div>
            <Grid xs={12} spacing={2} container style={{ textAlign: 'right' }}>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  name="email"
                  label={language.commons.labels.e_mail}
                  placeholder={language.commons.labels.e_mail}
                  variant="outlined"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  onBlur={() => {
                    if (formData.username === '') {
                      setFormData({
                        ...formData,
                        username: formData.email?.toLowerCase(),
                      });
                    }
                  }}
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  fullWidth
                  name="phone"
                  type="number"
                  label={language.commons.labels.phone}
                  placeholder="5xxxxxxxxx"
                  variant="outlined"
                  required
                  value={formData.phone}
                  onChange={handleChange}
                  onInput={(e) => {
                    let inputValue = e.target.value;
                    if (inputValue < 0) {
                      inputValue = '0';
                    }
                    if (inputValue.startsWith('0')) {
                      inputValue = inputValue.slice(1);
                    }
                    if (inputValue.length > 10) {
                      inputValue = inputValue.slice(0, 10);
                    }
                    if (inputValue !== e.target.value) {
                      e.target.value = inputValue;
                      setFormData({
                        ...formData,
                        phone: inputValue,
                      });
                    }
                  }}
                />
              </Grid>
            </Grid>
          </div>

          <hr />

          <div
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              flexDirection: 'column',
              gap: '10px',
            }}
          >
            <div>{language.commons.user_location}</div>
            <Grid xs={12} spacing={2} container style={{ textAlign: 'right' }}>
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <InputLabel>{language.commons.labels.mall}</InputLabel>
                  <Select
                    name="selectedMalls"
                    value={selectedMalls}
                    onChange={handleMallChange}
                    required
                    multiple
                    label={language.commons.labels.mall}
                  >
                    {malls
                      ?.filter(
                        (mall) =>
                          mall.offices &&
                          Array.isArray(mall.offices) &&
                          mall.offices.length >= 1
                      )
                      .map((mall) => (
                        <MenuItem key={mall.id} value={mall}>
                          {mall.title}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>

              {isCorporational && (
                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <InputLabel>{language.commons.column.store}</InputLabel>
                    <Select
                      name="selectedBranch"
                      value={selectedBranches}
                      multiple
                      required
                      onChange={handleChange}
                      label={language.commons.column.store}
                    >
                      {branches
                        ?.sort((a, b) => a.title.localeCompare(b.title))
                        .map((branch, index) => (
                          <MenuItem key={index} value={branch.branchID}>
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                gap: '4px',
                              }}
                            >
                              <span>{branch.title}</span>
                              <span
                                style={{ fontSize: '0.8em', color: '#999' }}
                              >
                                {'[' + branch.mallTitle + ']'}
                              </span>
                            </div>
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}
            </Grid>
          </div>

          {selectedMalls?.length > 0 && (
            <>
              <hr />
              <div
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  flexDirection: 'column',
                  gap: '10px',
                }}
              >
                <div>{language.commons.labels.malls}</div>
                <Grid
                  xs={12}
                  spacing={2}
                  container
                  style={{ textAlign: 'right' }}
                >
                  <Grid
                    item
                    xs={8}
                    container
                    style={{ display: 'contents' }}
                    alignItems="center"
                    spacing={2}
                  >
                    {selectedMalls.map((selectedMall, index) => (
                      <Grid item key={index}>
                        <Chip
                          label={
                            malls.find((mall) => mall?.id === selectedMall?.id)
                              ?.title || 'Unknown Mall'
                          }
                          variant="outlined"
                          sx={{ borderRadius: 0 }}
                          onDelete={() => handleRemoveMall(selectedMall)}
                        />
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
              </div>
            </>
          )}

          {storeNone && selectedBranches?.length > 0 && (
            <>
              <hr />
              <div
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  flexDirection: 'column',
                  gap: '10px',
                }}
              >
                <div>{language.commons.labels.stores}</div>
                <Grid
                  xs={12}
                  spacing={2}
                  container
                  style={{ textAlign: 'right' }}
                >
                  <Grid
                    item
                    xs={8}
                    container
                    style={{ display: 'contents' }}
                    alignItems="center"
                    spacing={2}
                  >
                    {selectedBranches.map((branchID, index) => (
                      <Grid item key={index}>
                        <Chip
                          label={
                            branches.find(
                              (branch) => branch.branchID === branchID
                            )?.title || 'Unknown Branch'
                          }
                          variant="outlined"
                          sx={{ borderRadius: 0 }}
                          onDelete={() => handleRemoveBranch(branchID)}
                        />
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
              </div>
            </>
          )}

          {/* Yetki alanı: accountant ve human-resource için GÖRÜNMEZ */}
          {!isAccountant && !isHR && (
            <>
              <hr />

              <div
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  flexDirection: 'column',
                  gap: '10px',
                }}
              >
                <div>{language.commons.labels.user_auth}</div>
                {formData?.type !== 'user' ? (
                  <Grid>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedRole?.includes('operations')}
                          onChange={() => handleRoleChange('operations')}
                          name="isOperator"
                        />
                      }
                      label={language.commons.labels.operation}
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedRole?.includes('manager')}
                          onChange={() => handleRoleChange('manager')}
                          name="isAdmin"
                        />
                      }
                      label={language.commons.labels.manager}
                    />
                    {formData?.type === 'admin' && (
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={selectedRole?.includes('regional-manager')}
                            onChange={() =>
                              handleRoleChange('regional-manager')
                            }
                            name="isAdmin"
                          />
                        }
                        label={language.commons.labels.regional_manager}
                      />
                    )}
                    {formData?.type === 'corporational' ? (
                      <>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={selectedRole?.includes('store-manager')}
                              onChange={() => handleRoleChange('store-manager')}
                              name="storeManager"
                            />
                          }
                          label={'Mağaza Yöneticisi'}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={selectedRole?.includes('easy-mall')}
                              onChange={() => handleRoleChange('easy-mall')}
                              name="easyMall"
                            />
                          }
                          label={'Easy Mall'}
                        />
                      </>
                    ) : (
                      <>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={selectedRole?.includes(
                                'technical-support-staff'
                              )}
                              onChange={() =>
                                handleRoleChange('technical-support-staff')
                              }
                              name="technicalSupportStaff"
                            />
                          }
                          label={language.commons.labels.technical_support}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={selectedRole?.includes(
                                'technical-support-manager'
                              )}
                              onChange={() =>
                                handleRoleChange('technical-support-manager')
                              }
                              name="technicalSupportManager"
                            />
                          }
                          label={language.commons.labels.technical_manager}
                        />
                      </>
                    )}
                  </Grid>
                ) : (
                  <Grid>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedRole?.includes('mall-management')}
                          onChange={() => handleRoleChange('mall-management')}
                          name="mallManagement"
                        />
                      }
                      label={language.commons.labels.mall_manager}
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedRole?.includes(
                            'mall-management-showcase'
                          )}
                          onChange={() =>
                            handleRoleChange('mall-management-showcase')
                          }
                          name="mallManagement"
                        />
                      }
                      label={language.commons.labels.mall_management_showcase}
                    />
                  </Grid>
                )}
              </div>

              {/* İptal yetkisi anahtarı: corporational ve user dışı için; HR/Accountant zaten gizli */}
              {formData?.type !== 'corporational' &&
                formData?.type !== 'user' && (
                  <>
                    <hr />
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'start',
                        padding: '5px 24px',
                      }}
                    >
                      <div style={{ textAlign: 'start', flexBasis: '25%' }}>
                        {language.commons.labels.cancel_auth}
                      </div>
                      <Switch
                        id="cancelSwitch"
                        checked={canCancel}
                        onChange={handleSwitchChange}
                        name="status"
                        color="primary"
                        inputProps={{ 'aria-label': 'primary checkbox' }}
                      />
                    </div>
                  </>
                )}
            </>
          )}
        </>
      </DialogContent>

      <DialogActions
        style={{
          textAlign: 'center',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          paddingBottom: '20px',
        }}
      >
        <Stack spacing={2} direction="row">
          <Button
            variant="outlined"
            onClick={() => {
              handleCloseDialog();
            }}
          >
            {language.commons.cancel}
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              handleComplete();
            }}
          >
            {modalType === 'edit'
              ? language.commons.update
              : language.commons.add_user}
          </Button>
        </Stack>
      </DialogActions>

      <Dialog
        open={dialogPasswordOpen}
        onClose={handleDialogPasswordClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {language.commons.update}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {language.components.AddEditUserModal.password_warning}
          </DialogContentText>
          <br />
          <DialogContentText
            disabled
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: 1,
            }}
            id="alert-dialog-description"
          >
            <TextField
              disabled
              fullWidth
              type="text"
              label={language.commons.labels.password}
              name="password"
              value={formData.password}
              margin="normal"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Button onClick={handleCopyPassword}>
                      <ContentCopyIcon color="action" />
                    </Button>
                  </InputAdornment>
                ),
              }}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogPasswordClose}>
            {language.commons.close}
          </Button>
        </DialogActions>
      </Dialog>
    </Dialog>
  );
};

export default AddEditUserModal;
